import React, { useMemo } from "react";

import {
  Modal,
  ModalBody,
  ModalHeader,
} from "@transfr-inc/dashboard-components";

import { SkillIcon } from "./skill.icon";

import "./career-skills.modal.scss";

export const CareerSkillsModal = ({ open, onClose, user, skills }) => {
  const userFullName = useMemo(
    () => `${user?.firstName} ${user?.lastName}`.trim(),
    [user]
  );

  const { specificSkills, generalSkills, totalSkills } = useMemo(() => {
    const generalSkills = [];
    const specificSkills = [];

    if (skills?.length) {
      for (const skill of skills) {
        if (skill.type === "general") {
          generalSkills.push({ ...skill });
        } else {
          specificSkills.push({ ...skill });
        }
      }
    }

    return { specificSkills, generalSkills, totalSkills: skills?.length || 0 };
  }, [skills]);

  return (
    <Modal open={open} modalClassName="career-skills-modal" onClose={onClose}>
      <ModalHeader
        label={userFullName}
        title={
          <div className="modal-title-badge">
            {"Skills"}
            <div className="badge">{totalSkills}</div>
          </div>
        }
      />
      <ModalBody>
        <div className="skills-container">
          <div className="skills-type-section">
            <div className="title">General</div>
            <div className="skills-image-container">
              {generalSkills.map((skill) => (
                <SkillIcon key={skill.id} skill={skill} />
              ))}
            </div>
          </div>
          <div className="skills-type-section">
            <div className="title">Specialized</div>
            <div className="skills-image-container">
              {specificSkills.map((skill) => (
                <SkillIcon key={skill.id} skill={skill} />
              ))}
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};
